export default {
  default: {
    remain: {
      en: `
        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from
        <span class="text-gold-50 font-bold">free mystery gift</span>
      `,
    },
    earned: {
      en: 'You\'ve earned a <span class="text-gold-50 font-bold">free mystery gift</span>',
    },
    description: {
      en: `
        It’s our 10th anniversary, but you get the presents!
        For a limited time, get a set packed with 5 scent vials
        of surprise 1.5 mL best-sellers on e-commerce purchases of {subTotal} and up.
      `,
    },
  },
  mothersDay: {
    remain: {
      en: `
        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from
        <span class="text-gold-50 font-bold">FREE gift!</span>
      `,
    },
    earned: {
      en: 'You\'ve earned a <span class="text-gold-50 font-bold">FREE GIFT</span>',
    },
    description: {
      en: `
        Spend {subTotal} or more and get a 10-piece gift set, featuring a luxe travel bag filled with nine delightful fragrance and beauty samples.
      `,
    },
  },
  fathersDay: {
    remain: {
      en: `
        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from
        <span class="text-gold-50 font-bold">FREE gift!</span>
      `,
    },
    earned: {
      en: 'You\'ve earned a <span class="text-gold-50 font-bold">FREE GIFT</span>',
    },
    description: {
      en: `
        Eligible customers will receive a free Confessions of a Rebel GET A ROOM Body Wash
        with any ecommerce purchase of {subTotal} or more.
        While supplies last. Offer applied automatically at checkout.
      `,
    },
  },
}
